<template>
  <div class="search-main">
    <div class="placeholder" :style="{ justifyContent: placeholderAlign, top: placeholderTop, fontSize: placeholderFont,
      opacity: placeholderTop == '-12px' ? 1 : 0.6 }">
      <div :style="noWrapStyle" class="no-wrap">
        <span v-if="isRequired" style="color: red; margin-right: 5px">**</span> {{ placeholder }}
      </div>
    </div>

    <input v-model="pSearch" @input="inputChanged" @keydown="keyDown" :disabled="isDisabled" @focus="setFocus" @blur="inputFocusOut" @click="setFocus"
      :style="{ borderWidth: borderWidth, borderRadius: borderWidth == '1px' ? '5px' : 0,
      textAlign: textAlign, padding: placeholder ? '14px 25px 9px 10px' : '7px 25px 7px 10px' }" ref="dropdownInput"/>

    <div class="arrow-down" :style="{ transform: searchItems.length == 0 ? 'scaleY(1)' : 'scaleY(-1)',
      opacity: isDisabled ? 0.3 : 1 }"></div>

    <div class="search-items" v-if="searchItems.length > 0" :style="{ textAlign: textAlign }" ref="searchBlock" @scroll="searchAreaScroll">
      <div class="filtered-caption" :style="{ top: `${clearFilterTop}px` }">
        <div>{{ searchItems.length }} of {{ items.length }} items</div>
        <img @mouseover="clearFilterHover = true" @mouseleave="clearFilterHover = false" @click="clearFilter" title="Clear search and selected item" src="https://img.icons8.com/windows/96/000000/clear-filters.png" height="15px"/>
      </div>

      <div class="item" v-for="i in visibleLength" :key="i" ref="itemDiv" @click="itemSelect()"
        @mouseenter="mouseOver(i)" @mouseleave="mouseLeave()">
        {{ i }}. {{ itemTypeObject ? searchItems[i - 1][pItemKey] : searchItems[i - 1] }}
      </div>
    </div>

    <div v-if="pErrorMessage" class="error-box" :style="{ justifyContent: placeholderAlign }"
      @click="setFocus()">
      <div class="error-message">
        {{ pErrorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
var index = -2;
var dropdownArrowClicked = false;
var watching = true;

export default {
  components: {
  },
  data: function() {
    return {
      pSelectedObject: {},
      searchItems: [],
      visibleLength: 50,
      placeholderFont: '12px',
      placeholderTop: '-1px',
      pSearch: '',
      pSelectedItem: '',
      clearFilterHover: false,
      itemTypeObject: true,
      clearFilterTop: 0,
      pErrorMessage: ''
    }
  },
  props: {
    placeholderAlign: { type: String, default: 'flex-start' },
    noWrapStyle: { type: String, default: 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis' },

    // Public properties
    items: { type: Array, default: function() { return [] } }, // The items in the dropdown
    itemKey: { type: String, default: '' }, // The key of the item in the dropdown, if leave it as empty string, it will automatically takes the second key in the object
    placeholder: { type: String, default: 'Items' }, // The placeholder of the dropdown
    textAlign: { type: String, default: 'left' }, // Text align of the dropdown (left, center, right)
    selectedItem: { type: String, default: '' }, // The string of the selected item
    selectedObject: { type: Object, default: function() { return {} } }, // The selected object in the dropdown
    isDisabled: { type: Boolean, default: false }, // Set as true, and the user will not be able to select or type in the dropdown
    errorMessage: { type: String, default: '' }, // Set the error message of the dropdown
    search: { type: String, default: '' }, // Get the value of the input
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this dropdown is required
    borderWidth: { type: String, default: '0 0 1px 0' } 

    // Public events
    // @selected - fired when an item is select, returns the selected item
  },
  methods: {
    inputChanged: function(e) {
      this.clearFilterTop = 0;
      this.$emit('update:search', this.pSearch);

      watching = false;

      if (this.itemTypeObject) {
        this.pSelectedObject = null;
        this.$emit('update:selectedObject', this.pSelectedObject);
      } else {
        this.pSelectedItem = '';
        this.$emit('update:selectedItem', this.pSelectedItem);
      }

      if (!this.pSearch) {
        this.searchItems = [];
        return;
      }

      this.searchItems = [];

      setTimeout(() => {
        watching = true;
        if (this.itemTypeObject) {
          this.searchItems = this.items.filter((i) => {
            return i[this.pItemKey].toString().toLowerCase().includes(this.pSearch.toLowerCase());
          });
        } else {
          this.searchItems = this.items.filter((i) => {
            return i.toLowerCase().includes(this.pSearch.toLowerCase());
          });
        }

        if (this.visibleLength > this.searchItems.length) {
          this.visibleLength = this.searchItems.length;
        } else if (this.searchItems.length > 50) {
          this.visibleLength = 50;
        } else {
          this.visibleLength = this.searchItems.length;
        }
      }, 10);
    },
    keyDown: function(e) {
      var allItems = this.$refs.itemDiv;

      if (e.key == 'ArrowDown') {
        if (this.searchItems.length == 0) {
          this.arrowMouseDown(null);
        }

        index++;

        if (index >= this.searchItems.length) {
          index--;
          return;
        }

        allItems.forEach((a) => {
          a.className = 'item';
        });

        allItems[index].className = 'item item-active';
        allItems[index].scrollIntoView({ behavior: "auto", block: "center" });
      } else if (e.key == 'ArrowUp') {
        index--;
        if (index <= -1) {
          index++;
          return;
        }

        allItems.forEach((a) => {
          a.className = 'item';
        });

        allItems[index].className = 'item item-active';
        allItems[index].scrollIntoView({ behavior: "auto", block: "center" });
      } else if (e.key == 'Enter') {
        if (this.searchItems.length == 0) {
          return;
        }

        if (index < 0) {
          index = 0;
        }

        this.itemSelect();

        this.searchItems = [];
      } else if (e.key == 'Escape') {
        this.searchItems = [];
      }
    },
    itemSelect: function() {
      if (this.itemTypeObject) {
        this.pSelectedObject = this.searchItems[index];
        this.$emit('update:selectedObject', this.pSelectedObject);

        this.$emit('selected', this.pSelectedObject);
      }
    },
    mouseOver: function(item) {
      index = item - 1;
      this.$refs.itemDiv.forEach((a) => {
        a.className = 'item';
      });

      setTimeout(() => {
        var div = this.$refs.itemDiv[index];
        if (div) {
          div.className = 'item item-active';
        }
      }, 1);
    },
    mouseLeave: function() {
      this.$refs.itemDiv.forEach((a) => {
        a.className = 'item';
      });
      index = -1;
    },
    arrowMouseDown: function(e) {
      if (this.isDisabled) {
        return;
      }
      
      if (e) {
        dropdownArrowClicked = true;
      }

      if (this.searchItems.length == 0) {
        setTimeout(() => {
          this.$refs.dropdownInput.focus();
        }, 10);
        if (this.pSearch) {
          if (this.itemTypeObject) {
            this.searchItems = this.items.filter((i) => {
              return i[this.pItemKey].toString().toLowerCase().includes(this.pSearch.toLowerCase());
            });
          } else {
            this.searchItems = this.items.filter((i) => {
              return i.toLowerCase().includes(this.pSearch.toLowerCase());
            });
          }
        } else {
          this.searchItems = this.items;
        }
      } else {
        this.searchItems = [];
      }
    },
    arrowMouseUp: function(e) {
      dropdownArrowClicked = false;
    },
    setFocus: function() {
      this.$emit('focusIn', this);
      
      if (this.pSearch) {
        this.searchItems = this.items.filter((i) => {
          return i[this.pItemKey].toString().toLowerCase().includes(this.pSearch.toLowerCase());
        });
      } else {
        this.searchItems = this.items;
      }

      this.clearFilterTop = 0;

      if (this.visibleLength > this.searchItems.length) {
        this.visibleLength = this.searchItems.length;
      } else if (this.searchItems.length > 50) {
        this.visibleLength = 50;
      } else {
        this.visibleLength = this.searchItems.length;
      }

      this.placeholderTop = '-12px';
      this.placeholderFont = '8px';

      this.pErrorMessage = '';
      this.$emit('update:errorMessage', this.pErrorMessage);

      this.$refs.dropdownInput.focus();
    },
    inputFocusOut: function() {
      if (this.clearFilterHover) {
        return;
      }
      
      setTimeout(() => {
        if (!dropdownArrowClicked) {
          if (index >= 0) {
            if (this.itemTypeObject) {
              this.pSearch = this.searchItems[index][this.pItemKey];
              this.$emit('update:search', this.pSearch);
              
              this.pSelectedItem = this.pSearch;
              this.$emit('update:selectedItem', this.pSelectedItem);

              this.pSelectedObject = this.searchItems[index];
              this.$emit('update:selectedObject', this.pSelectedObject);

              this.$emit('selected', this.pSelectedObject);
            } else {
              this.pSearch = this.searchItems[index];
              this.$emit('update:search', this.pSearch);

              this.pSelectedItem = this.pSearch;
              this.$emit('update:selectedItem', this.pSelectedItem);

              this.$emit('selected', this.pSelectedItem);
            }
            this.$refs.dropdownInput.focus();
          }

          this.searchItems = [];
          this.visibleLength = 50;
          if (!this.pSearch) {
            this.placeholderTop = '-1px';
            this.placeholderFont = '12px';
          }
        }
      }, 100);
    },
    clearFilter: function() {
      setTimeout(() => {
        this.pSearch = '';
        this.$emit('update:search', this.pSearch);
        
        this.pSelectedItem = '';
        this.$emit('update:selectedItem', this.pSelectedItem);

        if (this.itemTypeObject) {
          this.pSelectedObject = null;
          this.$emit('update:selectedObject', this.pSelectedObject);

          this.$emit('selected', this.pSelectedObject);
        } else {
          this.$emit('selected', this.pSelectedItem);
        }
        this.setFocus();
      }, 100);
    },
    searchAreaScroll: function(e) {
      this.clearFilterTop = e.target.scrollTop;
      if (e.target.scrollTop >= (e.target.scrollHeight - e.target.offsetHeight)) {
        var length = this.visibleLength + 50;
        if (length > this.searchItems.length) {
          this.visibleLength = this.searchItems.length;
        } else {
          this.visibleLength += 50;
        }
      }
    }
  },
  mounted() {
    this.itemTypeObject = typeof(this.items[0]) == 'object';

    if (this.itemTypeObject && !this.pItemKey) {
      this.pItemKey = Object.keys(this.items[0])[1];
      this.$emit('update:itemKey', this.pItemKey);
    }

    if (this.selectedObject) {
      this.pSelectedObject = this.selectedObject;
    }

    if (this.pSelectedItem) {
      var tempItem = this.pSelectedItem;
      this.pSelectedItem = null;
      this.pSelectedItem = tempItem;
    }

    if (this.pSearch) {
      this.placeholderTop = '-12px';
      this.placeholderFont = '8px';
    }

    if (this.itemKey) {
      this.pItemKey = this.itemKey;
    }

    if (this.errorMessage) {
      this.pErrorMessage = this.errorMessage;
    }

    switch (this.textAlign) {
      case 'left':
        this.placeholderAlign = 'flex-start';
        break;
      case 'center':
        this.placeholderAlign = 'center';
        break;
      case 'right':
        this.placeholderAlign = 'flex-end';
        break;
    }
  },
  watch: {
    searchItems: function(val) {
      if (val.length == 0) {
        index = -2;
      } else if (this.searchItems[0]['#'] == 0) {
        this.searchItems = this.searchItems.filter((s) => {
          return s['#'] != 0;
        });
      }
    },
    pSearch: function(val) {
      if (val) {
        this.placeholderTop = '-12px';
        this.placeholderFont = '8px';
      } else {
        watching = true;
        this.placeholderTop = '-1px';
        this.placeholderFont = '12px';

        this.pSelectedItem = '';
        this.$emit('update:selectedItem', this.pSelectedItem);

        this.pSelectedObject = null;
        this.$emit('update:selectedObject', this.pSelectedObject);
      }
    },
    items: function(val) {
      // if (this.items[0]['#'] == 0) {
      //   this.items.splice(0, 1);
      // }

      this.itemTypeObject = typeof(this.items[0]) == 'object';

      if (this.itemTypeObject && !this.pItemKey) {
        this.pItemKey = Object.keys(this.items[0])[1];
      }
    },
    pSelectedItem: function(val) {
      if (watching) {
        this.pSearch = val;
        this.$emit('update:search', this.pSearch);
      }

      watching = true;
    },
    pSelectedObject: function(val) {
      if (!val) {
        this.pSearch = '';
        this.$emit('update:search', this.pSearch);
      } else {
        this.pSearch = val[this.pItemKey];
        this.$emit('update:search', this.pSearch);
      }
    },
    selectedObject: function(val) {
      this.pSelectedObject = val;
    },
    itemKey: function(val) {
      this.pItemKey = val;
    },
    textAlign: function(val) {
      switch (val) {
        case 'left':
          this.placeholderAlign = 'flex-start';
          break;
        case 'center':
          this.placeholderAlign = 'center';
          break;
        case 'right':
          this.placeholderAlign = 'flex-end';
          break;
      }
    },
    errorMessage: function(val) {
      this.pErrorMessage = val;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.search-main {
  width: 100%;
  position: relative;
  height: 25px;
  padding: 0;
  margin: 2px 0px;
  // background-color: aqua;
}

input {
  width: 100%;
  height: 20px;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: rgba(128,128,128,0.5);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 14px 25px 9px 10px;
  background-color: transparent;
  position: relative;
  transition: $transition-time;
  font-size: 12px;
  top: -3px;
}

input:disabled {
  opacity: 0.8;
  background-color: rgba(200,200,200,0.3);
}

input:focus {
  outline: none;
  border-color: black;
}

.search-items {
  width: 100%;
  min-width: 200px;
  max-height: 300px;
  padding: 5px 0;
  position: absolute;
  background-color: white;
  // opacity: 0.5;
  border-color: black;
  border-style: solid;
  border-width: 0 1px 1px 1px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  overflow: auto;
  z-index: 999;
  font-size: 12px;
  padding-top: 25px;

  .filtered-caption {
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 10px;
    margin-bottom: 5px;
    top: 0;
    position: absolute;
    background-color: white;
    width: 100%;

    > img {
      margin-left: 5px;
      cursor: pointer;

      &:hover {
        background-color: rgba(200,200,200,0.5);
      }
    }
  }
}

.search-items .item {
  background-color: rgba(200,200,200,0.5);
  margin: 1px;
  padding: 2px 5px;
  cursor: pointer;
  padding-right: 20px;
}

.item-active {
  background-color: rgba(100,100,100,1) !important;
  color: white;
}

.arrow-down {
  border-width: 6px 6px 0px 6px;
  border-style: solid;
  border-color: rgba(64,64,64,1) transparent transparent transparent;
  position: absolute;
  border-radius: 10px;
  top: 7px;
  right: 5px;
  cursor: pointer;
  z-index: 110;
  pointer-events: none;
}

.placeholder {
  position: absolute;
  display: flex;
  // background-color: red;
  height: 100%;
  width: 100%;
  padding-left: 10px;
  padding-right: 25px;
  align-items: center;
  font-size: 12px;
  transition: 0.3s;
  opacity: 0.6;
}

.error-box {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: text;
  font-size: 12px;
  top: -6px;
}

.error-message {
  background-color: red;
  color: white;
  padding: 1px 5px;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 20px;
  text-overflow: ellipsis;
  position: relative;
  top: 3px;
}

.error-message:hover {
  overflow: visible;
  z-index: 111;
  border: 1px solid black;
}
</style>